/**
 * Tłumaczenie tekstów doboru elektrycznego, które przychodzą z `lib/` po polsku.
 *
 * `lib/warunkiDoboru` zwraca polskie etykiety i jednostki, a `lib` zostaje bez
 * zmian (liczy też dla PDF-a i testów). Tłumaczymy więc dopiero przy wyświetlaniu:
 * znany polski tekst dostaje klucz ze słownika `elektryka`, nieznany idzie dalej
 * bez zmian. W Polsce słownik zwraca dokładnie ten sam tekst.
 */
import { jestOstrzezeniemDcAc, jestOstrzezeniemPradu } from '../../lib/warunkiDoboru'

const KLUCZE_ETYKIET = {
  'Napięcie łańcucha przy mrozie': 'warunki.napiecie_mroz',
  'Napięcie w mrozie': 'warunki.napiecie_mroz_krotko',
  'Napięcie robocze w oknie MPPT': 'warunki.okno_mppt',
  'Napięcie robocze': 'warunki.okno_mppt_krotko',
  'Modułów w łańcuchu': 'warunki.liczba_modulow',
  'Przewymiarowanie DC/AC': 'warunki.dcac',
  'Prąd na wejściu MPPT': 'warunki.prad_mppt',
  'Prąd na wejściu DC': 'warunki.prad_dc',
}

const KLUCZE_JEDNOSTEK = { 'szt.': 'warunki.szt' }

/** Etykieta warunku w języku kraju; tekst spoza listy wraca bez zmian. */
export const etykietaWarunku = (t, tekst) => (
  KLUCZE_ETYKIET[tekst] ? t(KLUCZE_ETYKIET[tekst], { defaultValue: tekst }) : tekst
)

/** Jednostka warunku („szt.”); V, A i puste wracają bez zmian. */
export const jednostkaWarunku = (t, jednostka) => (
  KLUCZE_JEDNOSTEK[jednostka] ? t(KLUCZE_JEDNOSTEK[jednostka], { defaultValue: jednostka }) : jednostka
)

/**
 * Początki ostrzeżeń backendu w wersji rumuńskiej.
 *
 * `lib/warunkiDoboru` rozpoznaje ostrzeżenia o DC/AC i o prądzie po POLSKIM
 * początku zdania. Backend tłumaczy je dla Rumunii, więc bez tej listy dymki przy
 * warunkach zniknęłyby, a przycisk „Zaproponuj inny falownik” nigdy by się nie
 * pokazał. Zmiana tych początków w backendzie wymaga zmiany TUTAJ.
 */
const PREFIKSY_RO_DCAC = ['Supradimensionarea DC/AC', 'Supradimensionare DC/AC']
const PREFIKSY_RO_PRADU = ['Curentul panoului', 'Curentul de scurtcircuit al panoului']

const zaczynaSieOd = (tekst, prefiksy) => typeof tekst === 'string' && prefiksy.some((p) => tekst.startsWith(p))

export const ostrzezenieDcAc = (tekst) => jestOstrzezeniemDcAc(tekst) || zaczynaSieOd(tekst, PREFIKSY_RO_DCAC)

export const ostrzezeniePradu = (tekst) => jestOstrzezeniemPradu(tekst) || zaczynaSieOd(tekst, PREFIKSY_RO_PRADU)

/** Ostrzeżenia pokazywane w dymkach przy warunkach, nie w liście pod schematem. */
export const ostrzezeniePrzyWarunku = (tekst) => ostrzezenieDcAc(tekst) || ostrzezeniePradu(tekst)

/**
 * Dopina dymek do warunku, gdy `lib` nie rozpoznał przetłumaczonego ostrzeżenia.
 * W Polsce `lib` znajduje je sam, więc lista wraca bez zmian.
 */
export const uzupelnijDymki = (warunki, ostrzezenia = []) => warunki.map((w) => {
  if (w.podpowiedz) return w
  const wykrywacz = { dcac: ostrzezenieDcAc, prad: ostrzezeniePradu }[w.klucz]
  const dymek = wykrywacz ? (ostrzezenia || []).find(wykrywacz) : null
  return dymek ? { ...w, podpowiedz: dymek } : w
})
